import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,linkFormatter,
    historyDataFormatter,
    dateFormatter,
    customFormatter,
    getFieldByPathFormatter
} from 'util/Utils';
import classNames from 'classnames';
 
import config from  '../../../config';
import {
    UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT, ADD_SELECTED_PRODUCTS,
    REMOVE_SELECTED_PRODUCTS
} from "actions/actionTypes";
import moment   from 'moment'
class  DailyKPIReportTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},

        };

    }


    render() {
console.log('DailyKPIReportData', this.props.data  );
        return (
            <div className="top20 contractor-statistics-table databases-table">
                <BootstrapTable data={this.props.data} ref='table'

                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }

                >
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='groupTitle'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['groupTitle'], format: (value) => {

                            return <span className='blue text-bold' >{value}</span>
                        }
                    }} editable={ false } dataSort={false}>Title</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='title'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['title'], format: (value) => {

                            return <span >{value}</span>
                        }
                    }} editable={ false } dataSort={false}>Title</TableHeaderColumn>
                    {_.map(_.map(config.warehouseData,'MarketName'), marketName => {
                        return <TableHeaderColumn key={marketName} width="35px" dataAlign="center" dataField={marketName + '_value'}
                                                  dataFormat={ customFormatter } formatExtraData={ {
                            path:[  'getObject'],     format: (value) => {
//console.log('cell', _.get(value,[marketName + '_cell_style'],{})  );
                                return <span style={_.get(value,[marketName + '_cell_style'],{})} >{_.get(value,[marketName + '_value'],'')}</span>
                            }
                        }}
                                                  editable={ false } dataSort={false}>{marketName}</TableHeaderColumn>
                    })
                    }
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='Value'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['goals'], format: (value) => {

                            return value
                        }}}
                                       editable={ false } dataSort={false}>Goals</TableHeaderColumn>
                    <TableHeaderColumn dataField="Title" isKey={true} hidden={true} autoValue={ true }
                    >Id</TableHeaderColumn>

                </BootstrapTable>

            </div>
        );
    }
}

export default DailyKPIReportTable;
